import { render, staticRenderFns } from "./InventoryUpdateHistory.vue?vue&type=template&id=5e1e4998"
import script from "./InventoryUpdateHistory.vue?vue&type=script&lang=js"
export * from "./InventoryUpdateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports